import { ActionTree } from "vuex";
import { State } from "./state";
import { IS_LOADING, SET_DATA_ITEM, SET_ERROR, SET_SUCCESS } from "@/store/SimulatorTenStarStudents/types";
import axios from "@/utils/axios";

const URL = "/simulator-ten-star/students";

export const checkHasAccount = async (store: any, payload: any): Promise<boolean> => {
  store.commit(IS_LOADING, true);

  try {
    const { data } = await axios.get(`${URL}/${payload.studentId}/has-account`);
    store.commit(IS_LOADING, false);
    store.commit(SET_SUCCESS, true);
    return data;
  } catch (error: any) {
    store.commit(IS_LOADING, false);
    store.commit(SET_SUCCESS, false);
    store.commit(SET_ERROR, error.response?.data);
    return false;
  }
};

export const createStudent = async (store: any, payload: any): Promise<any> => {
  store.commit(IS_LOADING, true);
  return await axios
    .post(URL + `/${payload.studentId}`, payload.studentData)
    .then(({ data }) => {
      store.commit(IS_LOADING, false);
      store.commit(SET_DATA_ITEM, data);
      store.commit(SET_SUCCESS, true);
    })
    .catch(({ response }) => {
      store.commit(IS_LOADING, false);
      store.commit(SET_ERROR, response.data);
      store.commit(SET_SUCCESS, false);
    });
};

export const fetchSimulatorStudent = async (store: any, payload: any): Promise<any> => {
  store.commit(IS_LOADING, true);
  return await axios
    .get(URL + `/${payload.studentId}`)
    .then(({ data }) => {
      store.commit(IS_LOADING, false);
      store.commit(SET_DATA_ITEM, data);
      store.commit(SET_SUCCESS, true);
    })
    .catch(({ response }) => {
      store.commit(IS_LOADING, false);
      store.commit(SET_DATA_ITEM, {});
      store.commit(SET_ERROR, response.data);
      store.commit(SET_SUCCESS, false);
    });
};

export const updateStudent = async (store: any, payload: any): Promise<any> => {
  store.commit(IS_LOADING, true);
  return await axios
    .put(URL + `/${payload.studentId}`, payload.studentData)
    .then(({ data }) => {
      store.commit(IS_LOADING, false);
      store.commit(SET_DATA_ITEM, data);
      store.commit(SET_SUCCESS, true);
    })
    .catch(({ response }) => {
      store.commit(IS_LOADING, false);
      store.commit(SET_ERROR, response.data);
      store.commit(SET_SUCCESS, false);
    });
};

export default <ActionTree<State, any>>{
  createStudent,
  fetchSimulatorStudent,
  updateStudent,
  checkHasAccount,
};
